import { CalendarAlt, Clock, DescriptionItem, PlannedDurationIcon } from '@core/ui';
import { DateTime, Duration } from 'luxon';
import { useTranslation } from 'react-i18next';

interface Props {
    broadcastDateTime: DateTime;
    plannedDuration: Duration;
    isCancelled?: boolean;
}

export const WebinarDateTime = ({ broadcastDateTime, plannedDuration, isCancelled }: Props) => {
    const { t } = useTranslation();

    return (
        <dl className={`webinar-item-datetime ${isCancelled ? 'opacity-50' : ''}`}>
            <DescriptionItem icon={<CalendarAlt />} label={t('WebinarDetails.Label.Date')} hideLabel>
                <time dateTime={broadcastDateTime.toFormat('yyyy-LL-dd')}>{broadcastDateTime.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)}</time>
            </DescriptionItem>
            <DescriptionItem icon={<Clock />} label={t('WebinarDetails.Label.Time')} hideLabel>
                <time dateTime={broadcastDateTime.toLocaleString(DateTime.TIME_24_SIMPLE)}>{broadcastDateTime.toLocaleString(DateTime.TIME_24_SIMPLE)}</time>
            </DescriptionItem>
            <DescriptionItem icon={<PlannedDurationIcon />} label={t('WebinarDetails.Label.Duration')} hideLabel>
                <time dateTime={plannedDuration.toFormat("h'h' m'm'")}>{plannedDuration.toFormat('h:mm')}</time>
            </DescriptionItem>
        </dl>
    )
};